import * as React from 'react'

const SvgChevronRightIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.75 10L7.5 16.25l-.875-.875L12 10 6.625 4.625 7.5 3.75 13.75 10z"
      fill="#163250"
    />
  </svg>
)

export default SvgChevronRightIcon
